module.exports = __webpack_public_path__ + "static/media/washington-dc-12.a6d2b292.jpg";